import '.bn{flex-shrink:0;}.ssr-plugin'
import '.bp{padding:1rem;}.ssr-plugin'
import '.u{width:100%;}.ssr-plugin'
import '.b9{height:100%;}.ssr-plugin'
import '.bd{border:none;}.ssr-plugin'
import '.eh{background-color:transparent;}.ssr-plugin'
import '.ei{border-radius:0px;}.ssr-plugin'
import '.c{display:flex;}.ssr-plugin'
import '.g{flex-direction:column;}.ssr-plugin'
import '.a6{align-items:stretch;}.ssr-plugin'
import '.ck{position:sticky;}.ssr-plugin'
import '.ej{top:4rem;}.ssr-plugin'
import '.ek{z-index:7;}.ssr-plugin'
import '.af{background-color:var(--palette-white);}.ssr-plugin'
import '.el{padding-bottom:1rem;}.ssr-plugin'
import '.t{margin-bottom:1rem;}.ssr-plugin'
import '.em{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.a2{position:fixed;}.ssr-plugin'
import '.cl{top:0px;}.ssr-plugin'
import '.b7{left:0px;}.ssr-plugin'
import '.b8{right:0px;}.ssr-plugin'
import '.en{bottom:0px;}.ssr-plugin'
import '.eo{z-index:9999;}.ssr-plugin'
import '.ep{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.ch{justify-content:flex-end;}.ssr-plugin'
import '.bb{flex:1;}.ssr-plugin'
import '.at{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bn bp u b9 bd eh ei"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="c g a6"
    >
      <div className="ck ej ek af el t em c"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="a2 cl b7 b8 en eo af ep c g"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bp c ch em"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bb at">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
